import { render, staticRenderFns } from "./SourcesBrowse.vue?vue&type=template&id=540af1ac&scoped=true"
import script from "./SourcesBrowse.vue?vue&type=script&lang=js"
export * from "./SourcesBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540af1ac",
  null
  
)

export default component.exports